export default __webpack_public_path__ + "static/desktop_13-3242c33cc975b629969049336053ca39.webp";